{
   "admin" : {
      "index_view" : {
         "actions" : {
            "log_in" : "Log in",
            "log_out" : "Log out"
         },
         "message" : {
            "logged_in" : "You are currently logged in as {name}.",
            "not_logged_in" : "You aren't currently logged in with admin account."
         },
         "title" : "Digital signage"
      },
      "language_names" : {
         "english" : "English",
         "german" : "German"
      },
      "login_view" : {
         "actions" : {
            "back_to_login" : "Back to login",
            "change_user" : "Change user",
            "corporate_login" : "Corporate",
            "login" : "Log in"
         },
         "controls" : {
            "email" : "E-mail",
            "password" : "Password"
         },
         "labels" : {
            "are_you_not_user" : "Not {user}?",
            "external_auth" : {
               "checking" : "Working...",
               "failed" : "Login failed, try again.",
               "inuse" : "This corporate account is already linked with another any2any account. Please try logging in using that account.",
               "preparing" : "Preparing authentication...",
               "start" : "Redirecting to authentication provider...",
               "user_exists_not_linked" : "We could not log you in as your account already exists on the any2any platform. Please first log in using your any2any user name and password and then update your profile to your corporate provider. Once done, the corporate button will work as expected."
            },
            "provider_category" : {
               "corporate" : "Use your corporate account",
               "internal" : "Login with e-mail & password"
            }
         },
         "title" : {
            "default" : "Digital signage",
            "external_auth" : "Corporate login",
            "page_title" : "Login"
         }
      },
      "pairing_view" : {
         "actions" : {
            "cancel" : "Cancel",
            "retry" : "Retry"
         },
         "steps" : {
            "display_information" : {
               "actions" : {
                  "proceed" : "Proceed"
               },
               "fields" : {
                  "description" : "Display description",
                  "name" : "Display name"
               },
               "message_input_information" : "Please enter required information about the display",
               "title" : "Display information"
            },
            "layout_selection" : {
               "actions" : {
                  "proceed" : "Proceed"
               },
               "errors" : {
                  "resolving" : "There was an error while resolving layouts data"
               },
               "message" : {
                  "click_to_proceed" : "Click button below the table to proceed",
                  "select_layout" : "Select layout which should be assigned to the display. This step is optional."
               },
               "search_placeholder" : "Search for a layout...",
               "table" : {
                  "grid_size" : "Grid size",
                  "name" : "Name",
                  "no_layouts_found_message" : "No layouts found",
                  "widgets" : "Widgets"
               },
               "title" : "Layout selection"
            },
            "location_selection" : {
               "actions" : {
                  "proceed" : "Proceed"
               },
               "errors" : {
                  "resolving" : "There was an error while resolving locations data"
               },
               "message" : {
                  "click_to_proceed" : "Click button below the table to proceed",
                  "select_location" : "Select location by clicking on a given row"
               },
               "search_placeholder" : "Search for a location",
               "table" : {
                  "address" : "Address",
                  "name" : "Name",
                  "name_and_address" : "Name and address"
               },
               "title" : "Location selection"
            },
            "printer_config" : {
               "actions" : {
                  "proceed" : "Proceed"
               },
               "form" : {
                  "brother_model_name" : "Model",
                  "brother_serial" : "Serial",
                  "channel" : "Channel",
                  "enabled" : "Enabled"
               },
               "message" : {
                  "click_to_proceed" : "Click button below to proceed",
                  "configure_printer" : "Printer configuration"
               },
               "title" : "Printer configuration"
            },
            "result" : {
               "actions" : {
                  "logout" : "Logout"
               },
               "errors" : {
                  "pairing" : "There was an error while pairing device"
               },
               "message_pairing_in_progress" : "Pairing in progress, please wait...",
               "message_pairing_success" : "Display was successfully paired with the location. You can leave this page now.",
               "title" : "Result"
            },
            "summary" : {
               "actions" : {
                  "pair" : "Pair display with location"
               },
               "message" : {
                  "printer_config" : "Printer configuration: {enabled}",
                  "selected_display_description" : "Display description: {description}",
                  "selected_display_name" : "Display name: {name}",
                  "selected_layout" : "Selected layout: {name}",
                  "selected_location" : "Selected location: {name}"
               },
               "title" : "Summary"
            },
            "verification" : {
               "errors" : {
                  "invalid_pairing_data" : "Invalid pairing data, can't authenticate with server",
                  "unauthorized" : "You do not have required permission to perform this operation"
               },
               "message" : "Collecting and verifying necessary information...",
               "title" : "Verification"
            }
         },
         "title" : "Display pairing"
      },
      "profile_menu" : {
         "actions" : {
            "logout" : "Log out"
         }
      }
   },
   "common" : {
      "actions" : {
         "cancel" : "Cancel",
         "confirm" : "Confirm"
      },
      "page_title" : {
         "suffix" : "any2any digital signage"
      },
      "qrcode_scanner" : {
         "errors" : {
            "no_cameras" : "No cameras detected",
            "no_permissions" : "You must grant permissions to access a camera"
         }
      },
      "states" : {
         "disabled" : "Disabled",
         "enabled" : "Enabled"
      },
      "validation_errors" : {
         "required" : "Input is required"
      }
   },
   "initialization" : {
      "message" : "Please wait...",
      "title" : "Initialization"
   },
   "maintenance" : {
      "actions" : {
         "go_back" : "Go back",
         "reset_all_and_reload" : "Reset all stored data and go back",
         "restore_credentials" : "Restore saved credentials",
         "store_credentials" : "Store credentials for later"
      },
      "title" : "Maintenance panel"
   },
   "page404" : {
      "countdown_message" : "This page will close in {seconds} seconds",
      "message" : "We couldn't find what you were looking for.",
      "title" : "404"
   },
   "pairing" : {
      "qrcode_card" : {
         "message" : "Scan the QR code on another device to proceed with pairing.",
         "title" : "Pair your display"
      }
   },
   "signage" : {
      "badge_print_process" : {
         "status" : {
            "failure" : "Printing failed, see additional information below",
            "in_progress" : "Your badge is being printed, please wait...",
            "initializing" : "Initializing badge printing...",
            "pending" : "Printing is pending",
            "success" : "Your badge was printed successfully"
         },
         "status_code" : "Error code",
         "timeout_message" : "Printing took too long, please try again"
      },
      "error_view" : {
         "errors" : {
            "unauthorized" : "Display isn't authorized",
            "undefined_layout" : "Display doesn't have a layout assigned",
            "unknown" : "We don't know what happened, sorry"
         },
         "redirecting_in_seconds" : "Redirecting in {seconds} seconds",
         "title" : "Something went wrong",
         "trying_again_in_seconds" : "Trying again in {seconds} seconds"
      },
      "information_modal" : {
         "countdown_information" : "This window will close automatically in {seconds} seconds"
      },
      "layout_view" : {
         "title" : "digital signage"
      },
      "printers_list_modal" : {
         "channel" : "Channel",
         "model" : "Model",
         "no_printers_discovered" : "No printers found",
         "provider" : "Provider",
         "serial" : "Serial",
         "title" : "Discovered printers list"
      },
      "qrcode_action_failure_modal" : {
         "action_not_supported" : "Operation not supported",
         "action_timed_out" : "Operation timed out, please try again",
         "checked_in" : "Sorry this terminal does not support self-check ins",
         "checked_out" : "Sorry this terminal does not support self-checkouts",
         "different_qrcode_message" : "QR code was different than the first one",
         "not_recognized_message" : "QR code wasn't recognized",
         "title" : "Something went wrong"
      },
      "qrcode_action_success_modal" : {
         "checked_in" : {
            "message" : "Your host {hostName} will be informed that you have arrived and are in the building",
            "title" : "Thank you for checking in"
         },
         "checked_out" : {
            "message" : "Check out was successful, have a nice day!",
            "title" : "Thank you for checking out"
         }
      },
      "qrcode_confirmation_modal" : {
         "action_label" : {
            "checked_in" : "For check in",
            "checked_out" : "For check out",
            "please_wait" : "Please wait"
         },
         "countdown_message" : "Please scan your QR code again within the next {seconds} seconds",
         "title" : {
            "with-name" : "Welcome, {name}",
            "without-name" : "Welcome"
         }
      },
      "widgets" : {
         "header" : {
            "weather" : {
               "description" : {
                  "broken_clouds" : "Broken clouds",
                  "clear_sky" : "Clear sky",
                  "few_clouds" : "Few clouds",
                  "mist" : "Mist",
                  "rain" : "Rain",
                  "scattered_clouds" : "Scattered clouds",
                  "shower_rain" : "Shower rain",
                  "snow" : "Snow",
                  "thunderstorm" : "Thunderstorm"
               }
            }
         },
         "metric" : {
            "enabled_value" : {
               "co2" : "CO2",
               "humidity" : "Humidity",
               "illumination" : "Illumination",
               "occupancy" : "Occupancy",
               "people_count" : "People count",
               "rssi" : "RSSI",
               "temperature" : "Temperature"
            }
         },
         "qrcode_scanner" : {
            "message" : "Please scan your QR Code placing it into the frame of the camera",
            "title" : "QR code scanner"
         },
         "room_status" : {
            "availability_text" : {
               "available" : "Available",
               "available_at" : "Available at {time}",
               "available_till" : "Available till {time}"
            }
         }
      }
   }
}
